import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M9.82 6.39a2.43 2.43 0 0 0-3.43 0L5.33 5.33a3.93 3.93 0 0 1 5.55 0L9.82 6.39Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.08 3.08A7.1 7.1 0 0 1 13.7 12.5l1.14 1.13c.66-.31 1.47-.2 2.02.35l3.63 3.63c.7.69.7 1.81 0 2.5l-.36.37c-.7.7-1.82.7-2.51 0l-3.63-3.63a1.78 1.78 0 0 1-.27-2.16l-1.1-1.1A7.1 7.1 0 0 1 3.09 3.1Zm9 1.06a5.6 5.6 0 1 0-7.94 7.94 5.6 5.6 0 0 0 7.93-7.94Zm3.71 10.9a.28.28 0 0 0-.39 0l-.36.36c-.11.11-.11.29 0 .4l3.63 3.62c.1.1.28.1.39 0l.36-.36c.1-.11.1-.29 0-.4l-3.63-3.62Z"
    />
    <path d="M1 16h2v-1.5H1V16ZM8 18.5H1V17h7v1.5ZM1 21h11v-1.5H1V21Z" />
  </svg>
);
